var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8721 1.5H7.12207C6.50075 1.5 5.99707 2.00369 5.99707 2.625C5.99707 3.24632 6.50075 3.75 7.12207 3.75H10.8721C11.4934 3.75 11.9971 3.24632 11.9971 2.625C11.9971 2.00369 11.4934 1.5 10.8721 1.5Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99707 11.25H8.56853M5.99707 8.25H11.9971",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9971 2.625C13.1621 2.66011 13.8571 2.79006 14.3381 3.27103C14.9971 3.93004 14.9971 4.99068 14.9971 7.11197V11.9996C14.9971 14.1209 14.9971 15.1816 14.3381 15.8406C13.679 16.4996 12.6184 16.4996 10.4971 16.4996H7.49706C5.37575 16.4996 4.31509 16.4996 3.65608 15.8406C2.99708 15.1816 2.99707 14.1209 2.99707 11.9996L2.99708 7.11202C2.99707 4.99069 2.99707 3.93003 3.65608 3.27102C4.13704 2.79005 4.83195 2.66011 5.997 2.625",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskBlack);
export default __webpack_public_path__ + "static/media/task-black.0a595bb5fb36dc60544a3f8de5d88902.svg";
export { ForwardRef as ReactComponent };